enum UserInfoFormEnum {
	Check = "check",
	Login = "login",
	Register = "register",
	Reset = "reset",
	NewPassword = "new-password",
	None = "",
}

export default UserInfoFormEnum
